import { OnlineClientImpl } from './client';
import type { NetEnv } from './env';
import type { OnlineClient } from './types';
import type { UiStore } from '../ui-model/store';

export * from './types';
export { ClockSync, backoffDelay, TokenBucket } from './clock';
export { HybridTransport } from './hybrid-transport';
export { DEFAULT_STUN, iceServersWithDefault } from './peer';
export type { NetEnv, WebSocketLike } from './env';
export { WS_OPEN, clientVersionFor } from './env';

/**
 * The online client: a WebSocket lobby client with reconnect/backoff, clock sync, WebRTC (perfect negotiation,
 * unreliable DataChannel) and automatic relay fallback, over injected platform seams (`NetEnv`: the browser's in
 * apps/client `net/browser-env.ts`, a native shell's own; tests and tools pass fakes) and server URL.
 */
export const createOnlineClientWith = (ui: UiStore, env: NetEnv, url: () => string): OnlineClient =>
  new OnlineClientImpl(ui, env, url);
